<kendo-grid [data]="queryLogicData" class="wrap-cell-content">
  <kendo-grid-column field="selection" title="Selection"> </kendo-grid-column>
  <kendo-grid-column field="field" title="Field"> </kendo-grid-column>
  <kendo-grid-column field="value" title="Value"></kendo-grid-column>
</kendo-grid>
<hyperkit-typography
  variant="emphasized"
  size="sm"
  align="center"
  color="primary"
  >Condition: {{ queryLogicCondition }}</hyperkit-typography
>
